import type { TimestampInMillis, UUID } from '@cobliteam/common-types';

import type { BaseDriverInfo } from '../deviceTrip';

export interface IdentificationToken {
  tokenId: string;
  cobliInternalId: string;
  fleetId?: UUID;
  driverId?: UUID;
  associatedToFleetAt?: TimestampInMillis;
  status: IdentificationTokenStatus;
  tokenType: IdentificationTokenType;
}

export interface IdentificationTokenV2 {
  id: string;
  alias: string;
  tokenId?: string;
  tokenAlias: string;
  status: string;
  tokenType: IdentificationTokenType;
  cobliId?: string;
  isExternal: boolean;
  fleetId: UUID;
  driverId?: UUID;
  associatedToFleetAt?: TimestampInMillis;
  associatedToDriverAt?: TimestampInMillis;
}

export interface TokenValidation {
  tokenId: string;
  cobliInternalId: string;
  fleetId: UUID;
  driver?: BaseDriverInfo;
}

export interface TokenValidationV2 {
  tokenId: string;
  tokenAlias?: string;
  isExternal: boolean;
  driver?: BaseDriverInfo;
}

export interface TokenToSave {
  id: string;
  alias: string;
}

export interface Associations {
  associations: DriverToTokenAssociation[];
}

export interface DriverToTokenAssociation {
  driverId: UUID;
  cobliInternalId: string;
}

export interface AssociationsV2 {
  associations: DriverToTokenAssociationV2[];
}

export interface DriverToTokenAssociationV2 {
  driverId: UUID;
  tokenAlias?: string;
}

export enum IdentificationTokenStatus {
  IN_STOCK = 'in_stock',
  COMMODATE = 'commodate',
  AWAITING_RETURN = 'awaiting_return',
  REFUNDED = 'refunded',
  TESTING = 'testing',
  DONATED = 'donated',
  INDEBTED = 'indebted',
  BROKEN = 'broken',
  LOST = 'lost',
  UNKNOWN = 'unknown',
}

export enum IdentificationTokenType {
  IBUTTON = 'ibutton',
  RFID = 'rfid',
  UNKNOWN = 'unknown',
}
